module.exports = __webpack_public_path__ + "files/285912f3ff9c836982dda36019cde508.png";